import { createAction } from "@redux/actions/actionCreators";

const [useAppendProductAsset, appendProductAsset] = createAction<{
  productUuid: string;
  /** Variant key to append to, or null to append to the product level. */
  variantKey: string | null;
  /** Identifier of the asset-typed field (e.g. "images"). */
  identifier: string;
  assetUuid: string;
}>("product/appendAsset");

export default useAppendProductAsset;
export { appendProductAsset };
